import { Box, ColorOptions, Icon, Spacer, Text } from '@jfs/ui-new'
import { colors } from '../../util/colors'

const statisticsData = [
  {
    id: 0,
    icon: 'FUND_TRANSFER',
    title: '300 Million+',
    subTitle: 'Transactions processed',
  },
  {
    id: 1,
    icon: 'SHOP',
    title: '100K+',
    subTitle: 'Unique merchants',
  },
  {
    id: 2,
    icon: 'TOKENIZED_CARD',
    title: '7 Million+',
    subTitle: 'Cards tokenized',
  },
]

interface Props {
  isTab: boolean
  isMobile: boolean
}

export const Statistics = ({ isMobile }: Props) => {
  const StatisticContent = statisticsData.map((item: any) => {
    return (
      <Box w={isMobile ? '100%' : 240} align={'center'} justify={'center'}>
        <Icon id={item.icon} color={colors.JIO_PRIMARY_ALPHA as ColorOptions} size={48} />
        <Spacer size={isMobile ? 24 : 32} />
        <Text
          title={item.title}
          color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
          fontFamily={'jiotype-black'}
          fontSize={isMobile ? 18 : 32}
        />
        <Spacer size={8} />
        <Text
          title={item.subTitle}
          color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
          fontFamily={'jiotype-medium'}
          fontSize={isMobile ? 14 : 18}
          opacity={0.7}
        />
      </Box>
    )
  })
  return (
    <Box
      pb={120}
      pt={isMobile ? 120 : 250}
      flexDirection={isMobile ? 'column' : 'row'}
      gap={isMobile ? 64 : 120}
      justify={'center'}>
      {StatisticContent}
    </Box>
  )
}
